import { api } from "./client";

export const PaymentAPI = {
  createOrder: async (planData) => {
    return api.post("/payment/create-order", planData);
  },

  verifyPayment: async (paymentData) => {
    return api.post("/payment/verify", paymentData);
  },

  getSubscription: async () => {
    return api.get("/payment/subscription");
  },
};
